export default __webpack_public_path__ + "static/media/discount1.6ecefaf8.jpg";